/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OccupationCostForecastExaminationApiModel } from './occupationCostForecastExaminationApiModel';


export interface OccupationCostForecastCapabilityApiModel { 
    capabilityId: number;
    code: string;
    category?: number | null;
    name: string;
    intervalMonths: number;
    isMerged: boolean;
    examinations: Array<OccupationCostForecastExaminationApiModel>;
}

